import React from 'react';

// Luxury Home Icon - More refined than standard Home
export const LuxuryHome = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M3 9.5L12 2l9 7.5v11a1 1 0 01-1 1H4a1 1 0 01-1-1v-11z" />
    <path d="M9 22V12h6v10" />
    <circle cx="12" cy="8" r="1" fill="currentColor" />
  </svg>
);

// Luxury Search Icon - Minimalist magnifying glass
export const LuxurySearch = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </svg>
);

// Luxury Compass Icon - More elegant than standard
export const LuxuryCompass = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="12" cy="12" r="10" />
    <polygon points="16.24,7.76 14.12,14.12 7.76,16.24 9.88,9.88 16.24,7.76" fill="currentColor" fillOpacity="0.1" />
    <path d="M8 16l2.5-2.5M16 8l-2.5 2.5" strokeWidth="1" />
  </svg>
);

// Luxury Sparkles Icon - More refined
export const LuxurySparkles = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 2v4M12 18v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M2 12h4M18 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83" />
    <circle cx="12" cy="12" r="2" fill="currentColor" fillOpacity="0.2" />
  </svg>
);

// Luxury Heart Icon - More elegant
export const LuxuryHeart = ({ className = "w-4 h-4", filled = false, ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.5">
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
  </svg>
);

// Luxury User Icon - More sophisticated
export const LuxuryUser = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="12" cy="8" r="5" />
    <path d="M3 21c0-4.97 4.03-9 9-9s9 4.03 9 9" />
  </svg>
);

// Luxury Phone Icon - More refined
export const LuxuryPhone = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
    <circle cx="16" cy="8" r="2" fill="currentColor" fillOpacity="0.1" />
  </svg>
);

// Luxury Mail Icon - More elegant
export const LuxuryMail = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="M2 6l10 7L22 6" />
  </svg>
);

// Luxury Globe Icon - More sophisticated
export const LuxuryGlobe = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
  </svg>
);

// Luxury MapPin Icon - More refined
export const LuxuryMapPin = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" fill="currentColor" fillOpacity="0.1" />
  </svg>
);

// Luxury Users Icon - Group of people, more elegant
export const LuxuryUsers = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="9" cy="7" r="4" />
    <path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" />
    <circle cx="16" cy="4" r="2" />
    <path d="M20 8v6M23 11h-6" strokeWidth="1" />
  </svg>
);

// Luxury Bed Icon - More sophisticated
export const LuxuryBed = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M2 4v16M2 8h20v10H2zM12 4v4" />
    <circle cx="8" cy="6" r="2" fill="currentColor" fillOpacity="0.1" />
    <path d="M2 12h20" strokeWidth="1" />
  </svg>
);

// Luxury Bath Icon - More elegant bathtub
export const LuxuryBath = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M9 6a3 3 0 100 6h6a3 3 0 100-6" />
    <path d="M4 12v6a2 2 0 002 2h12a2 2 0 002-2v-6" />
    <path d="M4 12h16" />
    <circle cx="8" cy="18" r="1" fill="currentColor" />
    <circle cx="16" cy="18" r="1" fill="currentColor" />
  </svg>
);

// Luxury Star Icon - More refined
export const LuxuryStar = ({ className = "w-4 h-4", filled = false, ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.5">
    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
  </svg>
);

// Luxury Calendar Icon - More elegant
export const LuxuryCalendar = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <circle cx="8" cy="14" r="1" fill="currentColor" />
    <circle cx="12" cy="14" r="1" fill="currentColor" />
    <circle cx="16" cy="14" r="1" fill="currentColor" />
  </svg>
);

// Luxury Clock Icon - More sophisticated
export const LuxuryClock = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12,6 12,12 16,14" />
    <circle cx="12" cy="12" r="1" fill="currentColor" />
  </svg>
);

// Luxury Euro Icon - More elegant
export const LuxuryEuro = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M18.5 7.5C17.5 6.5 16 6 14 6c-4 0-7 3-7 6s3 6 7 6c2 0 3.5-.5 4.5-1.5" />
    <path d="M7 10h6M7 14h6" strokeWidth="1.5" />
  </svg>
);

// Luxury Menu Icon - More refined hamburger
export const LuxuryMenu = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <line x1="3" y1="8" x2="21" y2="8" />
    <line x1="3" y1="16" x2="21" y2="16" />
    <circle cx="5" cy="8" r="1" fill="currentColor" />
    <circle cx="5" cy="16" r="1" fill="currentColor" />
  </svg>
);

// Luxury Close/X Icon - More elegant
export const LuxuryClose = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
    <circle cx="12" cy="12" r="1" fill="currentColor" fillOpacity="0.1" />
  </svg>
);

// Luxury ChevronRight Icon - More refined arrow
export const LuxuryChevronRight = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <polyline points="9,18 15,12 9,6" />
    <circle cx="15" cy="12" r="1" fill="currentColor" fillOpacity="0.2" />
  </svg>
);

// Luxury Shield Icon - More elegant security symbol
export const LuxuryShield = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M9 12l2 2 4-4" strokeWidth="1.5" />
  </svg>
);

// Luxury Award Icon - More sophisticated trophy
export const LuxuryAward = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="12" cy="8" r="7" />
    <polyline points="8.21,13.89 7,23 12,20 17,23 15.79,13.88" />
    <circle cx="12" cy="8" r="3" fill="currentColor" fillOpacity="0.1" />
  </svg>
);

// Social Media Icons - Minimalist luxury versions
export const LuxuryInstagram = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const LuxuryFacebook = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
  </svg>
);

export const LuxuryTwitter = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
  </svg>
);

export const LuxuryLinkedin = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z" />
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

// Partner Icons - Minimalist luxury versions
export const MichelinIcon = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12l2 2 4-4" strokeWidth="1.5" />
    <circle cx="12" cy="12" r="3" fill="currentColor" fillOpacity="0.1" />
  </svg>
);

export const RelaisIcon = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M3 9.5L12 2l9 7.5v11a1 1 0 01-1 1H4a1 1 0 01-1-1v-11z" />
    <path d="M12 7v3M9 15h6" strokeWidth="1.5" />
    <circle cx="12" cy="5" r="1" fill="currentColor" />
  </svg>
);

export const LeadingIcon = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    <circle cx="12" cy="10" r="2" fill="currentColor" fillOpacity="0.1" />
  </svg>
);

export const VirtuosoIcon = ({ className = "w-4 h-4", ...props }) => (
  <svg className={className} {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M6 3h12l4 6-10 12L2 9l4-6z" />
    <path d="M12 7v6M9 10h6" strokeWidth="1" />
  </svg>
);